import type { ErrorInfo, ReactNode } from 'react';

import { Component } from 'react';

import ErrorPage from '../pages/ErrorPage';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
    };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  override componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Error boundary:', error, errorInfo);
  }

  override render() {
    if (this.state.hasError) {
      return <ErrorPage error={this.state.error?.message} />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
